import axios from 'axios';
import utilsJS from '@/plugins/utils.js';
const querystring = require('querystring');

const HttpCommon = axios.create({
  baseURL: utilsJS.getServiceUrl(),
  headers: {
    'Content-type': 'application/json',
  },
});

const instanceGateway = axios.create({
  baseURL: utilsJS.getServiceUrlGateway(),
});

var qs = require('query-string');

HttpCommon.interceptors.request.use(
  (config) => {
    config.headers.Authorization = localStorage.getItem('access_token');
    return config;
  },
  (error) => Promise.reject(error)
);

instanceGateway.interceptors.request.use(
  (config) => {
    config.headers =  {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': utilsJS.getBasicToken()
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor
HttpCommon.interceptors.response.use(
  function (response) {
    localStorage.setItem('dt_ultima_requisicao', new Date().getTime());
    return response;
  },
  function (error) {
    const originalRequest = error.config
    if (error.response) {
      let value = error.response;
      const isRequisicaoLogin =
        !!originalRequest.url && originalRequest.url.startsWith('/auth');

      if (utilsJS.sessaoExpirada() && !isRequisicaoLogin) {
        if (!originalRequest._retry) {
          originalRequest._retry = true;

          return instanceGateway
            .post('/token', qs.stringify({ grant_type: 'client_credentials' }))
            .then((response) => {
              // Salva novo token
              localStorage.setItem(
                'access_token',
                response.data.token_type + ' ' + response.data.access_token
              );
              // Refaz a requisição original
              return HttpCommon(originalRequest);
            })
            .catch(() => {
              // Se até o refresh falhar então limpa e redireciona
              localStorage.clear();
              window.location.href = '/dentista';
            });
        }
      }

      if (value.status === 401 && value.config.url != '/token') {
        if (!originalRequest._retry) {
          originalRequest._retry = true
          return instanceGateway.post('/token', qs.stringify({ 'grant_type': 'client_credentials' }))
          .then((response) => {
            localStorage.setItem( 'access_token', response.data.token_type + ' ' + response.data.access_token );
            return HttpCommon(originalRequest)
          })
          .catch(() => Promise.reject(error));
        }
      }
    }
    return Promise.reject(error);
  }
);

export default HttpCommon;